/** Entries for the project settings search box. */
export const sensitivitySettingsIndex = [
  {
    label: "Sensitivity level (normal, confidential, restricted)",
    tab: "Sensitivity",
    path: "/sensitivity",
    keywords:
      "sensitive data confidential restricted classification level private health personal no export only assigned people phones offline protect",
  },
];
